import React from "react";
import SelectField from "../../forms/select-field";
import FromTo from "../../../assets/icons/from-to";
import InputField from "../../forms/input-field";
import { useFormikContext } from "formik";
import ItemsSelectField from "../../forms/items-select-field";
import ItemsInputField from "../../forms/items-input-field";
import moment from "moment";

const StocktransferHeadSec = ({
  warehouseList = [],
  warehouse = "",
  binLocationList = [],
  disabled = false,
  initialData = {},
}) => {
  const { values, setFieldValue } = useFormikContext();

  // Build source options: gray out the selected destination for Stock IN / Transfer Request
  const sourceOptions = warehouseList.map((opt) => {
    const shouldDisable =
      (values?.stock_management_action === "stock_in" ||
        values?.stock_management_action === "stock_transfer_request") &&
      opt.value === values?.to_warehouse_id;
    return shouldDisable ? { ...opt, isDisabled: true } : opt;
  });

  // Build destination options: gray out the selected source for Stock OUT
  const destinationOptions = warehouseList.map((opt) => {
    const shouldDisable =
      values?.stock_management_action === "stock_out" &&
      opt.value === values?.from_warehouse_id;
    return shouldDisable ? { ...opt, isDisabled: true } : opt;
  });

  // Handle date validation on blur
  const handleDateBlur = (e) => {
    console.log("Date blur triggered:", e.target.value); // Debug log
    const inputDate = e.target.value;
    const today = moment().format("YYYY-MM-DD");

    // If no input date, set to today's date
    if (!inputDate) {
      console.log("No input date, setting to today:", today);
      setFieldValue("posting_date", today);
      return;
    }

    // Check if date format is valid (YYYY-MM-DD)
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(inputDate)) {
      console.log("Invalid format, setting to today:", today);
      setFieldValue("posting_date", today);
      return;
    }

    // Check if date is valid using moment
    const inputMoment = moment(inputDate, "YYYY-MM-DD", true);
    const todayMoment = moment(today, "YYYY-MM-DD");

    // If date is invalid, set to today's date
    if (!inputMoment.isValid()) {
      console.log("Invalid date, setting to today:", today);
      setFieldValue("posting_date", today);
      return;
    }

    // If date is in the past, set to today's date
    if (inputMoment.isBefore(todayMoment)) {
      console.log("Past date, setting to today:", today);
      setFieldValue("posting_date", today);
      return;
    }

    // Save the valid future date
    console.log("Valid date, saving:", inputDate);
    setFieldValue("posting_date", inputDate);
  };

  return (
    <>
      <div className="min-h-[8rem] flex items-center w-full">
        <div className="bg-[var(--add-billing-head-bg)] border-radius h-[87px] flex items-center px-3 w-full gap-4">
          <div className="w-[16%]">
            <ItemsSelectField
              handleSelect={(selectedOption) => {
                if (
                  selectedOption?.value === "stock_in" ||
                  selectedOption?.value === "stock_transfer_request"
                ) {
                  setFieldValue("to_warehouse_id", warehouse);
                  setFieldValue("from_warehouse_id", "");
                } else if (selectedOption?.value === "stock_out") {
                  setFieldValue("from_warehouse_id", warehouse);
                  setFieldValue("to_warehouse_id", "");
                } else if (selectedOption?.value === "in_store_transfer") {
                  setFieldValue("from_warehouse_id", warehouse);
                  setFieldValue("to_warehouse_id", warehouse);
                }
                setFieldValue("data", [initialData]);
              }}
              options={stockActionList}
              placeholder="Select Action"
              isRequired={true}
              labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
              inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
              type="text"
              disabled={disabled}
              name="stock_management_action"
              label="Stock Management Action"
              isLabelReq={true}
            />
          </div>
          <div className="w-[16%]">
            <ItemsSelectField
              key={values?.stock_management_action + values?.to_warehouse_id}
              options={sourceOptions}
              placeholder="Select Source  "
              isRequired={true}
              labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
              inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
              type="text"
              disabled={
                disabled ||
                values?.stock_management_action === "stock_out" ||
                values?.stock_management_action === "in_store_transfer"
              }
              name="from_warehouse_id"
              label="Source (from)"
              isLabelReq={true}
            />
          </div>
          <div className="w-[16%]">
            <ItemsSelectField
              key={values?.stock_management_action + values?.from_warehouse_id}
              options={destinationOptions}
              placeholder="Select Destination"
              isRequired={true}
              labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
              inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
              type="text"
              disabled={
                disabled ||
                values?.stock_management_action === "stock_in" ||
                values?.stock_management_action === "in_store_transfer" ||
                values?.stock_management_action === "stock_transfer_request"
              }
              name="to_warehouse_id"
              label="Destination (to)"
              isLabelReq={true}
            />
          </div>
          <div className="w-[10%]">
            <ItemsInputField
              isRequired={false}
              labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
              inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
              type="date"
              disabled={disabled}
              name={`posting_date`}
              label="Transfer Date"
              isLabelReq={true}
              // min={moment().format("YYYY-MM-DD")}
              onChange={() => { }}
              onBlur={handleDateBlur}
            />
          </div>
          <div className="w-[40%]">
            <ItemsInputField
              alphanumericOnly={true}
              maxLength={50}
              placeholder="Enter Reason for Stock Transfer"
              isRequired={false}
              labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
              inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
              type="text"
              disabled={disabled}
              name={`stock_transfer_reason`}
              label="Reason"
              allowAll={true}
              isLabelReq={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default StocktransferHeadSec;

export const stockActionList = [
  {
    label: "Stock IN",
    value: "stock_in",
  },
  {
    label: "Stock OUT",
    value: "stock_out",
  },
  {
    label: "IN Store Transfer",
    value: "in_store_transfer",
  },
  {
    label: "Stock Transfer Request",
    value: "stock_transfer_request",
  },
];
